module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-position-1d43506dace1caa131cda4f6381ca31e.png";